function t(t){let e='';for(let n of Object.keys(t))t[n]&&(e+=' '+n);return e}function e(...t){return t.join(' ')}export{t as classNamez,e as classNamezJoin};
